import { render, staticRenderFns } from "./CommercialProducts.vue?vue&type=template&id=b8984b56&"
import script from "./CommercialProducts.vue?vue&type=script&lang=js&"
export * from "./CommercialProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports